<template>
    <div>
        <b-row>
            <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
      
          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="table.perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50,100]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>

        <b-table
            :items="filteredItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            :busy="table.isBusy"
            @row-clicked="rowClicked"
            hover
            striped
            >

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            
            <!-- Example scoped slot for select state illustrative purposes -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
                </template>
            </template>
            
            <template v-slot:cell(date)="data">
                {{ $utils.dateStringFormat(data.item.ar.dueDate) }}
            </template>

            <template v-slot:cell(movementValue)="data">
              <span>
                <b>{{ $utils.numberFormat(data.item.ar.totalValue) }}</b>
              </span>
            </template>

        </b-table>
       
        <p></p>

        <nav>
            <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>

        <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Confirmação de Pagamento"
            size="md">

            <account-component-payment-modal :account="selectedItem" @resp="handleResp"></account-component-payment-modal>

        </b-modal>
    </div>
</template>

<script>

import axios from "axios";
import AccountComponentPaymentModal from "./AccountComponentPaymentModal.vue";

export default {
  name: "AccountComponentPayment",
  components: {
    AccountComponentPaymentModal
  },
  props: {
    userId: Number
  },
  data() {
    return {
        editModal: false,
        selectedItem: {},
        items: [],
        filters: {
            key: ''
        },
        table: {
            fields: [
            //{key: 'show_details', label: "", thStyle: { width: "40px" } },
            //{key: 'id' },
            {key: 'date', label: 'Data', sortable: false, thStyle: { width: "150px" }  },
            {key: 'ar.description', label: 'Descrição', sortable: false },
            {key: 'movementValue', label: 'Valor', sortable: false, class: 'text-right', thStyle: { width: "150px" }},
            //{key: 'st', label: 'Status', sortable: false, thStyle: { width: "40px" } }
            ],
            selectMode:'single',
            filterable: ['username'],
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            currentPage: 1,
            perPage: 100,
            primaryKey: "id",
            transProps: {
            // Transition name
            name: 'flip-list'
            },
            isBusy: false,
        }
    }
  },
  computed: {
    propUserId() {
      if(!this.userId) return 0
      return this.userId
    },
    totalRows: function() { return this.getRowCount() },
    filteredItems: function() {
        var list = this.items.filter(item => {
            return ((this.filters.key == '' || item.ar.description.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
            //&& ( this.filters.movementTypeId == 0 || item.movementTypeId == this.filters.movementTypeId )
            )
        })
        return list
    }
  },
  methods: {
    getRowCount: function() {
        return this.items.length
    },
    openEditModal(item) {
        this.editModal = true        
    },
    rowClicked(item) {
        this.selectedItem = item
        this.openEditModal(item)
    },
    handleResp(obj) {
        this.editModal = false
        this.refreshData()
    },
 
    async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/franchise/payment?userId=" + this.propUserId + "&paymentStatusId=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.items = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });
       
    }
     
  },
  mounted: function() {
    this.refreshData()
  }
  
};

</script>
